/**
 * 置顶或取消置顶评论
 * @param id 评论ID
 * @param cancel 是否取消置顶
 */
export async function requestPinComment(id: number, cancel?: boolean) {
  return http.post('/v1/comment/pin', {
    id,
    cancel: cancel ? 1 : undefined
  })
}
